/* global firebaseWebappKeys, apiEndpoint_saveDeviceToken, firebase */
if ('serviceWorker' in navigator && typeof firebaseWebappKeys !== 'undefined') {

    const firebaseOptions = {
        'appId': firebaseWebappKeys.appId,
        'projectId': firebaseWebappKeys.projectId,
        'apiKey': firebaseWebappKeys.apiKey,
        'messagingSenderId': firebaseWebappKeys.messagingSenderId
    };

    const firebasePublicApiKey = firebaseWebappKeys.keypair;

    firebase.initializeApp(firebaseOptions);

    let messaging;

    if (firebase.messaging.isSupported()) {

        messaging = firebase.messaging();

        messaging.usePublicVapidKey(firebasePublicApiKey);

        messaging.onMessage((payload) => {
            // console.log('Message received. ', payload);
            // [START_EXCLUDE]
            // Update the UI to include the received message.
            // appendMessage(payload);
            // [END_EXCLUDE]
        });

    }

    navigator
        .serviceWorker
        .register('service-worker.js')
        .then(function (reg) {

            if (firebase.messaging.isSupported()) {

                // Get Instance ID token. Initially this makes a network call, once retrieved
                // subsequent calls to getToken will return from cache.
                messaging
                    .getToken()
                    .then((currentToken) => saveFcmToken(currentToken))
                    .catch((err) => {
                        console.log('An error occurred while retrieving token. ', err);
                    });

                messaging.useServiceWorker(reg)

            }

        })
        .catch(function (err) {
            console.log("No it didn't. This happened: ", err)
        });

    // TODO: App installation process will be customized.
    // let deferredPrompt;
    window.addEventListener('beforeinstallprompt', (e) => {
        // Prevent the mini-infobar from appearing on mobile
        //   e.preventDefault();
        // Stash the event so it can be triggered later.
        //   deferredPrompt = e;
        // Update UI notify the user they can install the PWA
        //   showInstallPromotion();
    });

    function saveFcmToken(token) {

        if (token) {

            if (!localStorage.getItem('fcm-token')) {

                fetch(
                    apiEndpoint_saveDeviceToken,
                    {
                        method: "POST",
                        headers: {
                            'Accept': 'application/json',
                            'Content-Type': 'application/json'
                        },
                        body: JSON.stringify({device_token: token})
                    }
                ).then(() => {

                    localStorage.setItem('fcm-token', token)

                    App.prototype.setCookie("fcmDeviceToken", token, 30)

                })

            }


        } else {
            console.log('No Instance ID token available. Request permission to generate one.');
        }

    }

    AddToHomeScreen(iosAddToHomeScreenData)
}
